import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import PermissionMixin from '@/store/module/permission/mixin'
import { loading } from '@/shared/utils/UIHelper'

import ProfileRepository from '@/shared/http/repositories/access/profile'
import GroupRepository from '@/shared/http/repositories/access/group'
import GroupProfileRepository from '@/shared/http/repositories/access/groupprofile'
import AccountRepository from '@/shared/http/repositories/access/account'
import AccountProfileRepository from '@/shared/http/repositories/access/accountprofile'
import PermissionRepository from '@/shared/http/repositories/access/permission'
import PermissionModel from '@/shared/models/access/permissionmodel'
import PermissionForms from './permission-form'
import CompanyPciDocsRepository from '@/shared/http/repositories/pci/companyPciDocs'

export default {
  name: 'Permission',
  mixins: [ActionsForm, PermissionMixin],
  data () {
    return {
      data: PermissionModel,
      form: PermissionForms,
      permissionTypeUser: false,
      permissionTypeGroup: false,
      profiles: null
    }
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.descricao.maxlength)
    }
  },
  methods: {
    onLoad () {
      this.onLoadAllProfiles()
      this.form.tipo.options = [
        {text: this.$lang.Permission.OptionGroup, value: 'GRP'},
        {text: this.$lang.Permission.OptionUsers, value: 'USR'}
      ]
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
      this.onClearPermissions()
    },
    onCreate () {
      loading.push()
      PermissionRepository.Create(this.data)
        .then(this.onResultSimple)
        .finally(() => {
          if (this.form.tipo.value === 'USR') {
            CompanyPciDocsRepository.UpdatePermissionsByUser(this.form.contaID.value, this.company.id)
          } else {
            CompanyPciDocsRepository.UpdatePermissionsByGroup(this.form.grupoID.value, this.company.id)
          }
        })
        .catch(this.onException)
    },
    onLoadAllProfiles () {
      loading.push()
      ProfileRepository.GetAll()
        .then((response) => {
          this.profiles = response.data.data
          loading.close()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllGroup () {
      loading.push()
      this.onClearPermissions()
      GroupRepository.GetAll()
        .then((response) => {
          this.form.grupoID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllAccount () {
      loading.push()
      this.onClearPermissions()
      AccountRepository.GetAll()
        .then((response) => {
          this.form.contaID.options = this.onResultDropdown(response, null, acc => acc.nome + ' (' + acc.username + ')')
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onChangePermissionType (type) {
      if (!type) return

      this.onClearPermissions()
      switch (type) {
        case 'GRP':
          this.form.grupoID.value = null
          this.onLoadAllGroup()
          this.permissionTypeGroup = true
          this.permissionTypeUser = false
          break
        case 'USR':
          this.form.contaID.value = null
          this.onLoadAllAccount()
          this.permissionTypeUser = true
          this.permissionTypeGroup = false
          break
        default :
          this.permissionTypeUser = false
          this.permissionTypeGroup = false
          this.form.contaID.value = null
          this.form.grupoID.value = null
          break
      }
    },
    onChangeGroup (group) {
      this.onClearPermissions()
      if (group) {
        loading.push()
        GroupProfileRepository.GetAllByGroupId(group)
          .then((response) => {
            var data = response.data.data
            var profileList = this.profiles

            if (data && data.length > 0) {
              for (var x in data) {
                for (var i in profileList) {
                  if (profileList[i].id === data[x].id) {
                    const disabled = (
                      !this.hasRole(this.roles.RW_ADM_PERMISSIONS) && this.hasRole(this.roles.RW_ADM_PERMISSIONS_PCI) && !profileList[i].funcao.startsWith('RW_OPER_PCI')
                    )
                    this.form.permissoesUsadas.options.push({ 'text': profileList[i].nome, 'value': profileList[i].id, 'disabled': disabled })
                    profileList.splice(i, 1)
                  }
                }
              }
              if (!this.hasRole(this.roles.RW_ADM_PERMISSIONS) && this.hasRole(this.roles.RW_ADM_PERMISSIONS_PCI)) {
                this.form.permissoesDisponiveis.options = this.onSetDropdown(profileList.filter(p => p.funcao.startsWith('RW_OPER_PCI')))
              } else {
                this.form.permissoesDisponiveis.options = this.onSetDropdown(profileList)
              }
              this.onLoadAllProfiles()
            } else {
              if (!this.hasRole(this.roles.RW_ADM_PERMISSIONS) && this.hasRole(this.roles.RW_ADM_PERMISSIONS_PCI)) {
                this.form.permissoesDisponiveis.options = this.onSetDropdown(profileList.filter(p => p.funcao.startsWith('RW_OPER_PCI')))
              } else {
                this.form.permissoesDisponiveis.options = this.onSetDropdown(profileList)
              }
            }
            loading.close()
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onChangeAccount (user) {
      this.onClearPermissions()
      if (user) {
        loading.push()
        AccountProfileRepository.GetAllByAccountId(user)
          .then((response) => {
            var data = response.data.data
            var profileList = this.profiles
            if (data && data.length > 0) {
              for (var x in data) {
                for (var i in profileList) {
                  if (profileList[i].id === data[x].id) {
                    const disabled = (
                      !this.hasRole(this.roles.RW_ADM_PERMISSIONS) && this.hasRole(this.roles.RW_ADM_PERMISSIONS_PCI) && !profileList[i].funcao.startsWith('RW_OPER_PCI')
                    )
                    this.form.permissoesUsadas.options.push({ 'text': profileList[i].nome, 'value': profileList[i].id, 'disabled': disabled })
                    profileList.splice(i, 1)
                  }
                }
              }
              if (!this.hasRole(this.roles.RW_ADM_PERMISSIONS) && this.hasRole(this.roles.RW_ADM_PERMISSIONS_PCI)) {
                this.form.permissoesDisponiveis.options = this.onSetDropdown(profileList.filter(p => p.funcao.startsWith('RW_OPER_PCI')))
              } else {
                this.form.permissoesDisponiveis.options = this.onSetDropdown(profileList)
              }
              this.onLoadAllProfiles()
            } else {
              if (!this.hasRole(this.roles.RW_ADM_PERMISSIONS) && this.hasRole(this.roles.RW_ADM_PERMISSIONS_PCI)) {
                this.form.permissoesDisponiveis.options = this.onSetDropdown(profileList.filter(p => p.funcao.startsWith('RW_OPER_PCI')))
              } else {
                this.form.permissoesDisponiveis.options = this.onSetDropdown(profileList)
              }
            }
            loading.close()
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onClearPermissions () {
      this.form.permissoesDisponiveis.options = []
      this.form.permissoesUsadas.options = []
    },
    onAddPermissions () {
      var selected = this.form.permissoesDisponiveis.value
      var options = this.form.permissoesDisponiveis.options
      if (selected) {
        for (var x in selected) {
          for (var i in options) {
            if (options[i].value === selected[x]) {
              const useds = this.form.permissoesUsadas.options
              useds.push(options[i])
              this.form.permissoesUsadas.options = useds.sort((p1, p2) => p1.text < p2.text ? -1 : p1.text > p2.text ? 1 : 0)
              this.form.permissoesDisponiveis.options.splice(i, 1)
            }
          }
        }
      }
    },
    selectedProfile (value) {
      if (value) {
        return this.profiles.filter(p => p.id === value)[0]
      }
      return {}
    },
    availableProfile (value) {
      if (value) {
        return this.profiles.filter(p => p.id === value)[0]
      }
      return {}
    },
    onRemovePermissions () {
      var selected = this.form.permissoesUsadas.value
      var options = this.form.permissoesUsadas.options
      if (selected) {
        for (var x in selected) {
          for (var i in options) {
            if (options[i].value === selected[x]) {
              this.form.permissoesDisponiveis.options.push(options[i])
              this.form.permissoesUsadas.options.splice(i, 1)
            }
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/access/permission/permission.js